<template>
  <div>
    <CDialog>
      <h3 slot="title" class="heading-lined">{{ $t("share_page.heading") }}</h3>

      <div
        v-if="error.content.length > 0"
        :class="['alert', `alert-${error.type}`]"
      >
        {{ error.content }}
      </div>

      <p v-html="$t('share_page.dialog.p_1')"></p>

      <form class="mt-4" v-show="createdLink === null">
        <label>
          <div v-html="$t('share_page.dialog.add_message')"></div>
          <textarea
            type="text"
            class="form-control"
            maxlength="200"
            v-model="message"
          ></textarea>
        </label>
        <p class="char-count">{{ message.length }}/200</p>
      </form>

      <div v-show="createdLink !== null">
        <input
          class="form-control link-text"
          type="text"
          id="link"
          :value="createdLink"
          readonly
        />
        <button class="copy" id="copy" data-clipboard-target="#link">
          <i class="fa fa-copy"></i>
        </button>
      </div>

      <div slot="actions">
        <button
          class="btn btn-primary btn-block"
          @click="createLink()"
          v-show="this.createdLink === null"
          :disabled="isCreatingLink"
        >
          <i class="fa fa-share-square-o"></i>
          {{ $t("share_page.create_shareble") }}
        </button>

        <button
          class="btn btn-secondary btn-block mt-3"
          @click="close()"
          :disabled="isCreatingLink"
        >
          {{ closeButtonCaption }}
        </button>
      </div>
    </CDialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import Clipboard from "clipboard";
import CDialog from "./../Dialog";

export default {
  name: "ShareDialog",
  components: {
    CDialog,
  },
  data() {
    return {
      message: "",
      error: {
        content: "",
        type: "success",
      },
      isCreatingLink: false,
      createdLink: null,
    };
  },
  computed: {
    closeButtonCaption() {
      return this.createdLink === null
        ? this.$t("global.not_right_now")
        : this.$t("global.close");
    },
    ...mapGetters({
      profitlossMode: "settings/profitlossMode",
    }),
  },
  methods: {
    close() {
      this.resetDialog();
      this.toggleDialog("share", false);
    },
    async createLink() {
      try {
        this.isCreatingLink = true;
        this.setError("success", "");
        let id;
        if (this.profitlossMode) {
          id = await this.share_pl(this.message);
        } else {
          id = await this.share(this.message);
        }
        this.createdLink = `${location.protocol}//${location.host}/s/${id}`;
        this.setError("success", this.$t("share_page.messages.already"));
      } catch (error) {
        console.error(error);
        this.setError("danger", this.$t("share_page.messages.failed"));
      } finally {
        this.isCreatingLink = false;
      }
    },
    setError(type, content) {
      this.error = { type, content };
    },
    resetDialog() {
      this.setError("success", "");
      this.isCreatingLink = false;
      this.message = "";
    },
    ...mapActions({
      toggleDialog: "ui/toggleDialog",
      share: "portfolio/share",
      share_pl: "profitloss/share",
    }),
  },
  mounted() {
    const clipboard = new Clipboard("#copy");
    clipboard.on("success", (e) => {
      this.setError("success", this.$t("share_page.messages.copied"));
      e.clearSelection();
    });
    clipboard.on("error", () => {
      this.setError("danger", this.$t("share_page.messages.not_copied"));
    });
  },
};
</script>

<style lang="scss" scoped>
@import "~@/scss/variables";
@import "~@/scss/mixins";

textarea {
  resize: none;
  height: 60px;
}

.char-count {
  text-align: right;
  margin: 5px;
  font-size: 15px;
}

label {
  display: block;
}

.link-text {
  display: inline-block;
  width: calc(100% - 50px);
  background: #fff;
  font-size: 18px;
  padding: 18px;
  text-align: center;
}

.copy {
  width: 46px;
  margin: 0;
  border: 0;
  padding: 0;
  height: 58px;
  background: white;
  position: relative;

  &:active {
    top: 1px;
  }
}
</style>
